
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire34b5"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire34b5"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("hwrhg", function(module, exports) {
$parcel$export(module.exports, "register", function () { return $cc1a958bd304f822$export$6503ec6e8aabbaf; }, function (v) { return $cc1a958bd304f822$export$6503ec6e8aabbaf = v; });
$parcel$export(module.exports, "resolve", function () { return $cc1a958bd304f822$export$f7ad0328861e2f03; }, function (v) { return $cc1a958bd304f822$export$f7ad0328861e2f03 = v; });
var $cc1a958bd304f822$export$6503ec6e8aabbaf;
var $cc1a958bd304f822$export$f7ad0328861e2f03;
"use strict";
var $cc1a958bd304f822$var$mapping = new Map();
function $cc1a958bd304f822$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$cc1a958bd304f822$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $cc1a958bd304f822$var$resolve(id) {
    var resolved = $cc1a958bd304f822$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$cc1a958bd304f822$export$6503ec6e8aabbaf = $cc1a958bd304f822$var$register;
$cc1a958bd304f822$export$f7ad0328861e2f03 = $cc1a958bd304f822$var$resolve;

});

parcelRegister("lW4bD", function(module, exports) {
$parcel$export(module.exports, "getBundleURL", function () { return $ff82431dc1dc3028$export$bdfd709ae4826697; }, function (v) { return $ff82431dc1dc3028$export$bdfd709ae4826697 = v; });
// TODO: convert this file to ESM once HMR issues are resolved
var $ff82431dc1dc3028$export$5a759dc7a1cfb72a;
var $ff82431dc1dc3028$export$bdfd709ae4826697;
var $ff82431dc1dc3028$export$c9e73fbda7da57b6;
"use strict";
const $ff82431dc1dc3028$var$stackTraceUrlRegexp = /(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g;
const $ff82431dc1dc3028$var$bundleURL = {};
/**
 * Retrieves the cached bundle URL for a given identifier.
 * If the URL is not cached, it computes and stores it in the cache.
 *
 * @param {string} id - The identifier for the bundle.
 * @param {Error?} inputError - An error object to extract the stack trace from
 * (for testing purposes).
 * @returns {string} The URL of the bundle, without file name.
 */ function $ff82431dc1dc3028$var$getBundleURLCached(id, inputError) {
    let value = $ff82431dc1dc3028$var$bundleURL[id];
    if (!value) {
        value = $ff82431dc1dc3028$var$getBundleURL(inputError);
        $ff82431dc1dc3028$var$bundleURL[id] = value;
    }
    return value;
}
/** Get the URL without the filename (last / segment)
 *
 * @param {string} url
 * @returns {string} The URL with the file name removed
 */ function $ff82431dc1dc3028$var$getBaseURL(url) {
    return url.slice(0, url.lastIndexOf('/')) + '/';
}
function $ff82431dc1dc3028$var$getBundleURL(inputError) {
    try {
        throw inputError !== null && inputError !== void 0 ? inputError : new Error();
    } catch (err) {
        var matches = ('' + err.stack).match($ff82431dc1dc3028$var$stackTraceUrlRegexp);
        if (matches) // The first two stack frames will be this function and getBundleURLCached.
        // Use the 3rd one, which will be a runtime in the original bundle.
        return $ff82431dc1dc3028$var$getBaseURL(matches[2]);
    }
    return '/';
}
/**
 * @param {string} url
 * @returns {string}
 */ function $ff82431dc1dc3028$var$getOrigin(url) {
    return new URL(url).origin;
}
$ff82431dc1dc3028$export$5a759dc7a1cfb72a = $ff82431dc1dc3028$var$getOrigin;
$ff82431dc1dc3028$export$bdfd709ae4826697 = $ff82431dc1dc3028$var$getBundleURLCached;
$ff82431dc1dc3028$export$c9e73fbda7da57b6 = $ff82431dc1dc3028$var$getBaseURL;

});

var $1cedfc5476f2ae7a$exports = {};


(parcelRequire("hwrhg")).register((parcelRequire("lW4bD")).getBundleURL('fA8N8'), JSON.parse("[\"fA8N8\",\"confirmation-page.2dfef9f7.js\",\"ak5E0\",\"dev.87b06fdf.js\",\"i45nz\",\"Intro.60f4ddf4.js\",\"hqm9L\",\"Outro.ddc091d5.js\",\"1NzqT\",\"EN02.1c6a4e16.js\",\"3LNkL\",\"EN03.3d072cc3.js\",\"cvF1A\",\"EN04.a01d0096.js\",\"6NOTm\",\"DE02.00912328.js\",\"8X4tc\",\"DE03.b3bfffaa.js\",\"gx3Ew\",\"DE04.ea499195.js\",\"27aq8\",\"FR02.aa89fb61.js\",\"aXW7p\",\"FR03.2e1ba925.js\",\"37UKw\",\"FR04.1fc09911.js\",\"hGzhW\",\"ES02.687f86f5.js\",\"3okp2\",\"ES03.09a7c18d.js\",\"2INS9\",\"ES04.9dd96cb0.js\",\"g2fRD\",\"JA02.049fa53c.js\",\"8YKY8\",\"JA03.ac154524.js\",\"hvW6L\",\"JA04.563423d6.js\",\"785R9\",\"PTBR02.89d82c6e.js\",\"4D27a\",\"PTBR03.2daf582e.js\",\"9GXnu\",\"PTBR04.11c1a89f.js\",\"iEO7H\",\"Intro.1510cddf.js\",\"aEL7N\",\"Outro.b67eb138.js\",\"hTSUY\",\"EN02.62222ac7.js\",\"9OP6g\",\"EN03.11d67d87.js\",\"3VxYf\",\"EN04.2d8062aa.js\",\"5XT98\",\"DE02.9d027647.js\",\"aE6v0\",\"DE03.b7c2a8fb.js\",\"4QXl3\",\"DE04.b6f4b780.js\",\"8Ea94\",\"FR02.00984460.js\",\"emEyD\",\"FR03.4a1975d3.js\",\"kx63i\",\"FR04.f4855bb6.js\",\"35sEk\",\"ES02.c29f0dea.js\",\"4QWKe\",\"ES03.3a1fdc84.js\",\"47Ukn\",\"ES04.6f123d37.js\",\"7uGtS\",\"JA02.f1ad8a81.js\",\"h3uT4\",\"JA03.af0c15c8.js\",\"69cgK\",\"JA04.1a1ebd39.js\",\"6eOCB\",\"PTBR02.0b974789.js\",\"byXWj\",\"PTBR03.dc81a824.js\",\"d7vJk\",\"PTBR04.1bd45e30.js\",\"bVLgV\",\"1TAIL.00a929db.js\",\"kr6Hr\",\"1TOP.b750f740.js\",\"lQ2Ix\",\"2TAIL.db820913.js\",\"jfWmg\",\"2TOP.fa0f850e.js\",\"2kfLR\",\"3TAIL.9735131d.js\",\"3ERY9\",\"3TOP.11368ed7.js\",\"9AeSO\",\"4TAIL.5a3dcd81.js\",\"kruTN\",\"4TOP.bdf2cf0f.js\",\"c5ZWp\",\"5REFLOOP.a0bc1fc7.js\",\"4aKa0\",\"6LOOP.20758909.js\",\"dU9JP\",\"7OUTRO.bba5a2cb.js\",\"afYam\",\"SlackTeamsSpotlight.dce7a9f5.js\",\"2A8vK\",\"Ed.61b780ab.svg\",\"a6hlc\",\"Katina.9d77d506.svg\",\"bEhRS\",\"Myra.6a2e56a8.svg\",\"oEM2y\",\"Oliver.3c8edaab.svg\",\"aBy76\",\"slackSpotlight.c7655f37.svg\",\"c1x6w\",\"esm.45d34350.js\",\"2JqEa\",\"main.aeebaf9e.js\",\"2NyJK\",\"main.ca12dc12.js\",\"2yWIb\",\"main.6de0dbba.js\",\"8lipP\",\"main.053687ce.js\",\"4lKc9\",\"main.631e8d6d.js\",\"lxC77\",\"cs.2dd030b3.js\",\"g5LOK\",\"da.5cdd644a.js\",\"j932v\",\"de.ebb2bf3d.js\",\"9u82F\",\"en.73b2427a.js\",\"lIYZW\",\"en_GB.d8a20a39.js\",\"d0NCE\",\"en_ZZ.8b03057a.js\",\"djAyD\",\"es.b3d685db.js\",\"75opk\",\"et.3408d377.js\",\"kbrpe\",\"fi.f37820ce.js\",\"e90kC\",\"fr.56acbe04.js\",\"ck0lB\",\"hu.754b26c7.js\",\"c26Eo\",\"is.bcd19d8e.js\",\"3vJl0\",\"it.3d036436.js\",\"blAiY\",\"ja.249111c9.js\",\"kFtcB\",\"ko.1af4e415.js\",\"gmVIX\",\"nb.ae836857.js\",\"g1JpQ\",\"nl.4cf08350.js\",\"9iF0X\",\"pl.305815cf.js\",\"cssvc\",\"pt_BR.adbf8398.js\",\"kPGjP\",\"pt_PT.6edcd799.js\",\"lAqnd\",\"ro.400d75d8.js\",\"2WC7r\",\"ru.d37f04c9.js\",\"dPjF4\",\"sk.ba564609.js\",\"bSmKT\",\"sv.ff650436.js\",\"bEBNB\",\"th.e23426cd.js\",\"jhcJl\",\"tr.4630bbe5.js\",\"fIRMc\",\"uk.3782b24f.js\",\"foJ5Y\",\"vi.0713d8a5.js\",\"eoavR\",\"zh_TW.30d27505.js\",\"g3JkR\",\"zh.c7b3000a.js\",\"4FuR2\",\"cs.43517735.js\",\"XHFe6\",\"da.480c4f58.js\",\"lRNdr\",\"de.cecabc5a.js\",\"dyC2o\",\"en_GB.1c3d5359.js\",\"kNlhw\",\"en.e45114b0.js\",\"lLmjf\",\"en_ZZ.46ba82b5.js\",\"8Yoap\",\"es.4b83301e.js\",\"b0h7t\",\"fi.dc757aa0.js\",\"83SWO\",\"fr.ba129b6e.js\",\"57nVS\",\"hu.26fdaa5d.js\",\"16sPT\",\"it.9abf1260.js\",\"dQL4U\",\"ja.3723eb73.js\",\"cb39N\",\"ko.c527bd3c.js\",\"7u3pY\",\"nb.a294bd52.js\",\"b6BFI\",\"nl.710327ee.js\",\"8k2P1\",\"pl.00576610.js\",\"iP7d6\",\"pt_BR.0ff0160d.js\",\"874jG\",\"ru.ee034969.js\",\"cLQ8h\",\"sv.c5fe70b4.js\",\"lJFGv\",\"tr.c9318e91.js\",\"iGPnh\",\"th.2e72603f.js\",\"iZDZP\",\"uk.6676b39a.js\",\"7RbGI\",\"vi.2653e3d7.js\",\"85wRI\",\"zh_TW.c2faef73.js\",\"3PQHH\",\"zh.5b15f173.js\",\"aBYZ8\",\"cs.d78c955f.js\",\"3ZzQ4\",\"da.1efc0102.js\",\"7RvYL\",\"de.e3fec7b7.js\",\"aGRWz\",\"en_GB.19aa1d07.js\",\"3bV83\",\"en.4bc24061.js\",\"eZQaD\",\"en_ZZ.6980ca71.js\",\"6ZZAD\",\"es.336941a4.js\",\"gSgHk\",\"et.aee6b78f.js\",\"cqMMB\",\"fi.230273ff.js\",\"ja8C2\",\"fr.7bfcf586.js\",\"l5zaw\",\"hu.72e3c789.js\",\"eyNDi\",\"is.007cd578.js\",\"bPqAp\",\"it.ad0d27a1.js\",\"8eOgr\",\"ja.270bba2b.js\",\"jpm9w\",\"ko.8ab9f237.js\",\"csUD9\",\"nb.93c3936f.js\",\"7DJy1\",\"nl.62d001cc.js\",\"rhk3R\",\"pl.5aa6e5ec.js\",\"aRSus\",\"pt_BR.00329415.js\",\"fyQSW\",\"pt_PT.855a768b.js\",\"gv5NU\",\"ro.75f16ab8.js\",\"kT68O\",\"ru.2a157a50.js\",\"6ZCmq\",\"sk.762a8ae1.js\",\"7lRCn\",\"sv.4b605f11.js\",\"eqJGl\",\"tr.b050aade.js\",\"d0IR5\",\"th.79069c16.js\",\"dvvUW\",\"uk.314d4d79.js\",\"1bhYp\",\"vi.ad1bd2cc.js\",\"5Wmew\",\"zh_TW.e6e98b23.js\",\"i0aES\",\"zh.b0dd9c7f.js\",\"dtDSG\",\"WarningIllustration.a7c1b6da.js\",\"k7Wll\",\"WarningIllustration.ec26752f.png\"]"));


//# sourceMappingURL=confirmation-page.runtime.ce2ce606.js.map
